import { ConflictError, UnauthorizedError } from "../errors/http_errors";
import { Leaderboard } from "../models/leaderboard";

async function fetchData(input: RequestInfo, init?: RequestInit) {
  const response = await fetch(input, init);

  if (response.ok) {
    return response;
  } else {
    const errorBody = await response.json();
    const errorMessage = errorBody.error;
    if (response.status === 401) {
      throw new UnauthorizedError(errorMessage);
    } else if (response.status === 409) {
      throw new ConflictError(errorMessage);
    } else {
      throw Error(
        "Request failed with status: " +
          response.status +
          " message: " +
          errorMessage
      );
    }
  }
}

export async function fetchLeaderboard(): Promise<Leaderboard> {
  const response = await fetchData(
    `${process.env.REACT_APP_API_URL}/api/leaderboard/`,
    { method: "GET", credentials: "include" }
  );

  return response.json();
}

export async function fetchUserRank(): Promise<number> {
  const leaderboard = await fetchLeaderboard();
  return leaderboard.userRank;
}
